import { currencyDecimals, money, type MoneyInput } from './money';

const LOCALE = 'pt-BR';
const CURRENCY_SYMBOLS: Record<string, string> = { USD: 'US$', BRL: 'R$' };

export function formatMoney(value: MoneyInput | null | undefined, currency = 'USD', opts: { sign?: boolean } = {}): string {
  if (value === null || value === undefined) return '—';
  const d = money(value);
  const decimals = currencyDecimals(currency);
  const abs = d.abs().toFixed(decimals);
  const [int = '0', frac] = abs.split('.');
  const grouped = Number(int).toLocaleString(LOCALE);
  const body = frac ? `${grouped},${frac}` : grouped;
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
  const sign = d.isNeg() && !d.isZero() ? '-' : opts.sign && d.gt(0) ? '+' : '';
  return `${sign}${symbol} ${body}`;
}

export function formatNumber(value: number, decimals = 0): string {
  return value.toLocaleString(LOCALE, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function formatPercent(value: number | string, decimals = 1): string {
  return `${Number(value).toLocaleString(LOCALE, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}%`;
}

/** USD/BRL rate as people read it: "R$ 4,9918". */
export function formatFxRate(rate: MoneyInput): string {
  return `R$ ${money(rate).toFixed(4).replace('.', ',')}`;
}
